export enum FilterByEnum {
    RecordLocator = 0,
    EmailAddress = 1,
    DepartureDate = 2,
    BookingDate = 3,
    BookingStatus = 4
}
